import { useGetIsAndroidTWA } from "./useAndroidTWA";

export default function useIsAndroidAppRunningInsideWebView() {
  const isAndroidTWA = useGetIsAndroidTWA();
  const isRunningInsideWebViewEnv = !window.chrome;

  return isAndroidTWA && isRunningInsideWebViewEnv;
}
